import type { Program } from 'models';
import { useState } from 'react';
import { usePermissions } from 'permissions';
import { Card, Col, Row, ScrollToTop } from 'ui';
import { ProgramAboutDetails } from './program-about-details';
import { ProgramAboutTopbar } from './program-about-topbar';
import { ProgramDescription } from './program-description';
import { ProgramTags } from './program-tags';

type P = {
  program: Program;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramAboutContent = ({ program }: P) => {
  const [isLearnMoreOpened, setIsLearnMoreOpened] = useState(false);
  const { canSeeTags } = usePermissions();

  const onLearnMore = () => {
    setIsLearnMoreOpened(true);
  };

  const isTagsVisible = Boolean(program.tags?.length) && canSeeTags({ organizationId: program.organization?.id ?? '' });

  return (
    <Row gutter="ms">
      <ScrollToTop />
      <Col span={24}>
        <Card>
          <ProgramAboutTopbar program={program} />
        </Card>
      </Col>
      <Col span={24}>
        <Card>
          <ProgramDescription isLearnMoreOpened={isLearnMoreOpened} onLearnMore={onLearnMore} program={program} />
          {isLearnMoreOpened ? <ProgramAboutDetails program={program} /> : null}
          {isTagsVisible && program.tags ? <ProgramTags tags={program.tags} /> : null}
        </Card>
      </Col>
    </Row>
  );
};

export default ProgramAboutContent;
